import { getType } from 'mime';

export const SUPPORTED_DOCUMENT_FORMATS = [
	'pdf',
	'doc',
	'docx',
	'xls',
	'xlsx',
	'ppt',
	'pptx',
	'pages',
	'numbers',
	'txt',
]
	.map(getType)
	.filter(Boolean) as string[];
